<template>
  <div :class="['layout-wrap', extraClass]">
    <XHeader v-if="!resetPageHideComponent.includes('topMenu')" />
    <nuxt />
    <client-only>
      <LoginPop
        v-if="$store.state.app.showLoginPop"
        :style="resetPageHideComponent.includes('topMenu') && 'top:0'"
      />
    </client-only>
    <XFooter />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LoginPop from '../components/logic-common/LoginPop'
import XHeader from '~/components/layout/Header'
import XFooter from '~/components/logic-common/Footer'
export default {
  components: {
    XHeader,
    XFooter,
    LoginPop
  },
  computed: {
    ...mapGetters('app', ['resetPageHideComponent', 'hideRechargeType']),
    extraClass() {
      return ['', 'insertYSQQ'][this.hideRechargeType]
    }
  },
  created() {
    if (process.client) {
      this.$store.dispatch('getUserInfo')
      this.$store.dispatch('app/getServerList')
    }

    this.$store.commit(
      'app/setHideRechargeType',
      Number(this.$route.query?.rechargeType) || 0
    )

    // 初始化充值模块内组件的显示隐藏
    this.hideRechargeType &&
      this.initHideRechargeComponent(this.hideRechargeType)
  },
  methods: {
    ...mapActions('app', ['initHideRechargeComponent'])
  }
}
</script>
